"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFormatAddress = void 0;
const react_intl_1 = require("react-intl");
const useFormatAddress = () => {
    const { formatMessage } = (0, react_intl_1.useIntl)();
    return {
        formatAddress: (address) => {
            if (!address) {
                return formatMessage({ id: "messages.noAddress" });
            }
            const { addressLine1, addressLine2, city, country, state, zip } = address;
            return `${formatMessage({ id: `enums.country.${country}` })}${state ? `, ${state}` : ""}, ${city}, ${addressLine1}${addressLine2 ? `, ${addressLine2}` : ""}, ${zip}`;
        },
    };
};
exports.useFormatAddress = useFormatAddress;
//# sourceMappingURL=address.js.map